export function trackQuestionAnswered(questionKey, answer, surveySource = null) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalSurveyQuestionAnswered',
    data: {
      questionKey,
      answer,
      survey_source: surveySource,
    },
  });
}

export function trackBackButtonClicked(questionKey, surveySource = null) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalBackButtonClicked',
    data: {
      questionKey,
      survey_source: surveySource,
    },
  });
}

export function trackIntroductionGetStartedClicked() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalIntroductionGetStartedClicked',
  });
}
